import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import Subheader from 'material-ui/Subheader';
import _ from 'lodash';

import { fetchTaskProfiles } from '../../actions/taskprofiles';
import { fetchItemTypes } from '../../actions/itemtypes';
import ItemTypeIcon from '../Common/ItemTypeIcon';

import styles from './styles';

const SelectableList = makeSelectable(List);

class TaskProfileDrilldown extends React.Component {
  static propTypes = {
    fetchTaskProfiles: PropTypes.func.isRequired,
    // taskProfiles: PropTypes.array.isRequired,
    allTaskProfiles: PropTypes.array.isRequired,

    onChange: PropTypes.func.isRequired,
    selectable: PropTypes.bool,

    fetchItemTypes: PropTypes.func.isRequired,
    itemTypes: PropTypes.object.isRequired,
  };

  state = {
    taskProfiles: [],
    taskProfile: {},
  };

  componentWillMount() {
    this.props.fetchTaskProfiles();
    this.props.fetchItemTypes();
  }

  handleSelectTaskProfile = (evt, taskProfile) => {
    console.log('handleSelectTaskProfile', taskProfile);
    this.setState({
      taskProfile,
    });

    if (!this.props.selectable) {
      this.props.onChange([taskProfile]);
    }
  };

  handleAddTaskProfile = (taskProfile) => {
    // if (!this.props.selectable) {
    //   return this.handleSelectTaskProfile(null, taskProfile);
    // }

    console.log('handleAddTaskProfile', taskProfile);
    let taskProfiles = this.state.taskProfiles || [];
    if (this.props.selectable) {
      if (taskProfiles.indexOf(taskProfile) >= 0) {
        taskProfiles = taskProfiles.filter((tp) => tp.id !== taskProfile.id);
      } else {
        taskProfiles = taskProfiles.concat([taskProfile]);
      }
    } else {
      taskProfiles = [taskProfile];
    }

    this.props.onChange(taskProfiles);

    this.setState({
      taskProfiles,
      taskProfile,
    });

    // this.props.onChange(taskProfiles);
  };

  renderTaskProfileListItem(taskProfile, selected) {
    const iconName = this.props.selectable ? (selected ? 'done' : 'add') : 'list';
    const icon = <FontIcon className="material-icons" style={styles.stageIcon}>{ iconName }</FontIcon>;
    const iconColor = this.props.selectable && selected ? 'green' : null;

    return (<ListItem
      key={taskProfile.id}
      value={taskProfile}
      leftAvatar={<Avatar
        backgroundColor={iconColor}
        icon={icon}
        onClick={() => this.handleAddTaskProfile(taskProfile)}
      />}
      rightIcon={<FontIcon className="material-icons" style={styles.stageIcon}>chevron_right</FontIcon>}
      primaryText={taskProfile.name}
    />);
  }

  renderTaskProfileItemListItem(itemType, quantity) {
    if (itemType) {
      return (<ListItem
        key={itemType.id}
        leftAvatar={<Avatar
          icon={<ItemTypeIcon type={itemType} height={26}/>}/>}
        primaryText={itemType.name}
        secondaryText={`Quantity: ${quantity}`}
      />);
    } else {
      return null;
    }
  }

  renderTaskProfileItems(itemTypes = {}) {
    return (<div style={styles.taskProfileItems}>
      <Subheader>Items</Subheader>
      <List style={styles.itemsList}>
        { _.keys(itemTypes).map((id) => {
          return this.renderTaskProfileItemListItem(this.props.itemTypes[id], itemTypes[id]);
        })}
      </List>
    </div>);
  }

  render() {
    const selected = this.state.taskProfiles || [];
    const available = _.differenceBy(this.props.allTaskProfiles, selected, 'id');

    return (<div style={styles.container}>
      <div style={styles.taskProfiles}>
        <Subheader>Task Profiles</Subheader>
        <SelectableList
          value={this.state.taskProfile}
          onChange={this.handleSelectTaskProfile}>
          { selected.map((taskProfile) => this.renderTaskProfileListItem(taskProfile, true))}
          { available.map((taskProfile) => this.renderTaskProfileListItem(taskProfile, false))}
        </SelectableList>
      </div>
      { this.renderTaskProfileItems(this.state.taskProfile.itemTypes) }
    </div>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskProfiles,
    fetchItemTypes,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    allTaskProfiles: state.get('taskprofiles').get('taskProfiles').toJS(),
    itemTypes: state.get('itemtypes').get('itemTypes').toJS(),
    loading: state.get('taskprofiles').get('loading'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskProfileDrilldown);



// WEBPACK FOOTER //
// ./src/components/TaskProfileDrilldown/index.js